import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import {baseUrl, ipAddress, userName} from "../Univ";
function OwnerPayments() {
    const userId = localStorage.getItem("user_id");
    const [ownerId, setOwnerId] = useState(null);
    const [assignments, setAssignments] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedAssignment, setSelectedAssignment] = useState(null);
    const [paymentSummary, setPaymentSummary] = useState({});
    const [amount, setAmount] = useState("");
    const [mode, setMode] = useState("ONLINE");
    // ---------------- GET OWNER ----------------
    useEffect(() => {
        axios.get(
            baseUrl +
            "landowner-profile/" +
            userId +
            "/"
        )
            .then((res) => {
                if (res.data.length > 0) {
                    setOwnerId(
                        res.data[0].id
                    );
                }
            })
            .catch(console.log);
    }, [userId]);
    useEffect(() => {
        fetchAssignments();
    }, []);
    // ---------------- LOAD ASSIGNMENTS ----------------
    const fetchAssignments = async () => {
        try {
            setLoading(true);
            const reqRes = await axios.get(
                baseUrl + "landowner-req/"
            );
            const requirements = reqRes.data;
            let allAssignments = [];
            for (const req of requirements) {
                const assignRes = await axios.get(
                    baseUrl +
                    "assignment-requirement/" +
                    req.id +
                    "/"
                );
                allAssignments = [
                    ...allAssignments,
                    ...assignRes.data
                ];
            }
            const summaryObj = {};
            for (const assignment of allAssignments) {
                try {
                    const payRes = await axios.get(
                        baseUrl +
                        "payment-summary/" +
                        assignment.id +
                        "/"
                    );
                    summaryObj[assignment.id] =
                        payRes.data.total_paid;
                } catch (err) {
                    summaryObj[assignment.id] = 0;
                }
            }
            setPaymentSummary(summaryObj);
            setAssignments(allAssignments);
            setLoading(false);
        } catch (err) {
            console.log(err);
            setLoading(false);
        }
    };
    // ---------------- PAYMENT ----------------
    const makePayment = async () => {
        if (!selectedAssignment) {
            Swal.fire(
                "Error",
                "Select Assignment",
                "error"
            );
            return;
        }
        if (!amount) {
            Swal.fire(
                "Error",
                "Enter Amount",
                "error"
            );
            return;
        }
        try {
            // ---------------- SAVE PAYMENT ----------------
            const fd = new FormData();
            fd.append(
                "assignment",
                selectedAssignment.id
            );
            fd.append(
                "amount",
                amount
            );
            fd.append(
                "payment_date",
                new Date()
                    .toISOString()
                    .split("T")[0]
            );
            fd.append(
                "payment_mode",
                mode
            );
            fd.append(
                "owner_confirmed",
                true
            );
            fd.append(
                "worker_confirmed",
                false
            );
            fd.append(
                "addedby",
                userName
            );
            fd.append(
                "ip_add",
                ipAddress
            );
            await axios.post(
                baseUrl +
                "payment/",
                fd
            );
            // ---------------- UPDATE REQUIREMENT BUDGET ----------------
            const budgetFd = new FormData();
            budgetFd.append(
                "amount",
                amount
            );
            await axios.post(
                baseUrl +
                "update-requirement-budget/" +
                selectedAssignment.requirement.id +
                "/",
                budgetFd
            );
            Swal.fire(
                "Success",
                "Payment Saved Successfully",
                "success"
            );
            setAmount("");
            setMode("ONLINE");
            setSelectedAssignment(null);
            fetchAssignments();
        } catch (err) {
            console.log(
                err.response?.data
            );
            Swal.fire(
                "Error",
                "Unable To Save Payment",
                "error"
            );
        }
    };
    return (
        <section className="container mt-4">

            <div className="page-header">
                <h3>Owner Payments</h3>
                <small>
                    Manage worker payments and settlements
                </small>
            </div>

            {loading && (
                <div className="alert alert-info">
                    Loading Assignments...
                </div>
            )}

            {!loading &&
                assignments.length === 0 && (
                    <div className="alert alert-warning">
                        No Workers Assigned Yet
                    </div>
                )}

            <div className="row">

                {assignments.map((item) => (
                    <div
                        key={item.id}
                        className="col-lg-4 col-md-6 mb-4"
                    >

                        <div className="card app-card">

                            <div className="app-card-header">

                                <h5 className="mb-0">
                                    👨‍🌾 {item.worker?.name}
                                </h5>

                            </div>

                            <div className="app-card-body">

                                <p>
                                    <strong>🌱 Requirement :</strong>
                                    {" "}
                                    {item.requirement?.crop_type}
                                </p>

                                <p>
                                    <strong>📍 Location :</strong>
                                    {" "}
                                    {item.requirement?.location}
                                </p>

                                <p>
                                    <strong>📅 Present Days :</strong>
                                    {" "}
                                    {item.total_present_days}
                                </p>

                                <p>
                                    <strong>💰 Earned Till Date :</strong>
                                    <br/>
                                    <span
                                        style={{
                                            color: "#198754",
                                            fontSize: "20px",
                                            fontWeight: "bold"
                                        }}
                                    >
                ₹ {item.total_amount}
              </span>
                                </p>

                                <p>
                                    <strong>✅ Paid Till Date :</strong>
                                    <br/>
                                    <span
                                        style={{
                                            color: "#0d6efd",
                                            fontWeight: "bold"
                                        }}
                                    >
                ₹ {paymentSummary[item.id] || 0}
              </span>
                                </p>

                                <p>
                                    <strong>⚠ Pending :</strong>
                                    <br/>
                                    <span
                                        style={{
                                            color: "#dc3545",
                                            fontWeight: "bold"
                                        }}
                                    >
                ₹ {
                                        Number(item.total_amount) -
                                        Number(paymentSummary[item.id] || 0)
                                    }
              </span>
                                </p>
                                <span className="badge bg-success">
              {item.status}
            </span>

                            </div>

                            <div className="app-card-footer">

                                <button
                                    className="btn btn-action w-100"
                                    onClick={() => {
                                        setSelectedAssignment(item);
                                        setAmount(
                                            item.total_amount || ""
                                        );
                                    }}
                                >
                                    💳 Make Payment
                                </button>

                            </div>

                        </div>

                    </div>
                ))}

            </div>

            {/* PAYMENT MODAL */}

            {selectedAssignment && (
                <div
                    className="modal fade show app-modal"
                    style={{
                        display: "block",
                        backgroundColor: "rgba(0,0,0,.5)"
                    }}
                >

                    <div className="modal-dialog modal-dialog-centered">

                        <div className="modal-content">

                            <div className="modal-header">

                                <h5 className="modal-title">
                                    💳 Payment Entry
                                </h5>

                                <button
                                    type="button"
                                    className="btn-close btn-close-white"
                                    onClick={() =>
                                        setSelectedAssignment(null)
                                    }
                                />

                            </div>

                            <div className="modal-body">

                                <div className="app-modal-highlight">

                                    <h5>
                                        👨‍🌾 {selectedAssignment.worker?.name}
                                    </h5>

                                    <hr/>

                                    <p className="mb-1">
                                        <strong>
                                            Requirement:
                                        </strong>
                                        {" "}
                                        {selectedAssignment.requirement?.crop_type}
                                    </p>

                                    <p className="mb-1">
                                        <strong>
                                            Location:
                                        </strong>
                                        {" "}
                                        {selectedAssignment.requirement?.location}
                                    </p>

                                    <p className="mb-0">
                                        <strong>
                                            Recommended Amount:
                                        </strong>

                                        <span
                                            style={{
                                                color: "#198754",
                                                fontWeight: "bold",
                                                fontSize: "20px",
                                                marginLeft: "10px"
                                            }}
                                        >
                  ₹{selectedAssignment.total_amount}
                </span>
                                    </p>

                                </div>

                                <div className="mb-3">

                                    <label className="form-label">
                                        Amount
                                    </label>

                                    <input
                                        type="number"
                                        className="form-control"
                                        value={amount}
                                        onChange={(e) =>
                                            setAmount(
                                                e.target.value
                                            )
                                        }
                                    />

                                </div>

                                <div className="mb-3">

                                    <label className="form-label">
                                        Payment Mode
                                    </label>

                                    <select
                                        className="form-control"
                                        value={mode}
                                        onChange={(e) =>
                                            setMode(
                                                e.target.value
                                            )
                                        }
                                    >

                                        <option value="ONLINE">
                                            ONLINE
                                        </option>

                                        <option value="OFFLINE">
                                            OFFLINE
                                        </option>

                                    </select>

                                </div>

                            </div>

                            <div className="modal-footer">

                                <button
                                    className="btn btn-secondary"
                                    onClick={() =>
                                        setSelectedAssignment(null)
                                    }
                                >
                                    Close
                                </button>

                                <button
                                    className="btn btn-success-action"
                                    onClick={makePayment}
                                >
                                    Save Payment
                                </button>

                            </div>

                        </div>

                    </div>

                </div>
            )}

        </section>
    );
}
export default OwnerPayments;